import axios from 'axios';
import Constants, { fixProtocol } from '../../../constants/constants';
import { RestorativeProgram } from './types';

export const editPlayer = async (
  id: number,
  firstName: string,
  lastName: string,
  restorativePrograms: RestorativeProgram[]
) => {
  // TODO: Update URL with endpoint and uncomment this stuff out
  const restorativeProgramIds = restorativePrograms.map((program) => {
    return program.id;
  });

  const url = new URL(`${fixProtocol(Constants.BACKEND_URL)}/players/edit-restorative-player`);

  const config = {
    player_id: id,
    first_name: firstName,
    last_name: lastName,
    restorative_program_ids: restorativeProgramIds,
  };
  try {
    const response = await axios.post(url.toString(), config);
    return response;
  } catch (e) {
    return false;
  }
};
